// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://fzdkykdgygoyktimikzt.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZ6ZGt5a2RneWdveWt0aW1pa3p0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzE0OTEzMjAsImV4cCI6MjA4NzA2NzMyMH0.Kq4CoSelArDO2-XOehVVJiOlAXc3xekExMIt9WRIuNM";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});